// extracted by mini-css-extract-plugin
export default {"container":"AboutPage_container__Xh2nA","title":"AboutPage_title__7Q1AM","avatar":"AboutPage_avatar__oaPyO","bio":"AboutPage_bio__lMYxE"};